/**
 *
 */
export function createModalActions(set) {
    return {
        /**
         * Create and show a modal instance of a modal type registered in `modalRegistry`.
         * @param id - The id of the modal instance necessary to identify specific modal instance.
         * @param type - The type of the modal (according to `modalRegistry`)
         * @param config - Props passed to the modal component)
         */
        showModal: (id, type, config) => {
            set((prevState) => {
                if (prevState.openedModals.some((modal) => modal.id === id)) {
                    return prevState;
                }
                return {
                    openedModals: [...prevState.openedModals, { type, config, id }],
                };
            }, false, 'showModal');
        },
        /**
         * Hide a modal
         * @param id - The id of the modal instance
         */
        hideModal: (id) => {
            set((prevState) => ({
                openedModals: prevState.openedModals.filter((modal) => modal.id !== id),
            }), false, 'hideModal');
        },
    };
}
